//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import logo from '@assets/logo.png';
import axios from 'axios'
export default {
    data(){
        return{
            form: {
                grant_type: 'password',
                client_id: 'app_client',
                client_secret: 'app_secret',
                auth_type: '',
                username: '',
                password: '',
                open_id:'',
                code:'',
                state:''
            },
            size:'normal',
            logoSrc: logo,
            icon: 1,
            passw: "password",
            loginId:''
        }
    },
    methods: {
        /*登录函数*/
        login: function () {
            if(getSession('open_id')){
                this.form.code=  '';
                this.form.auth_type = 'wechat';
                this.form.open_id = getSession('open_id');
            }
            this.form.state = this.getSearch().state
            this.$store.dispatch('login', this.form);
            this.sourceEdit(this.form.username)
            if(this.$route.query.coupon){
              setLocal('coupon',1)
            }
        },
        // 微信登录
        logins:function(form){
            this.$store.dispatch('login', form);
            this.sourceEdit('微信授权登录'+this.getSearch().code)
        },

        // 立即注册
        register(){
            var state=''
            if(!this.getSearch().state){
                state=6;
            }else{
                if(this.getSearch().state.indexOf('redirect')!=-1){
                   state=6;
                }else{
                   if(this.getSearch().state.indexOf('-')!=-1){
                        state=this.getSearch().state.split('-')[0];
                    }else{
                        if(this.getSearch().state.indexOf('#')!=-1){
                            state=this.getSearch().state.split('#')[0];
                        }else{
                            state=this.getSearch().state;
                        }
                    }
                }
            }
            this.$router.push({
                path:'/register?state='+state
            })
        },

        // 忘记密码
        forgetpwd(){
            this.$router.push({
                path:'/forgetPwd'
            })
        },

        // 获取ip所在城市、区等信息
        getIPCity() {
            var data = {
                key: 'KSPBZ-V5L33-5EM3D-35N5X-DIY66-CRF7J', //密钥
            }
            var url = 'https://apis.map.qq.com/ws/location/v1/ip' //腾讯地理位置信息接口
            data.output = 'jsonp' // 解决跨域问题
            this.$jsonp(url, data).then((res) => {
                this.sourceAccess(res.result.ip,res.result.ad_info.province+res.result.ad_info.city)
                return res
            }).catch((error) => {})
        },

        // 添加来源
        sourceAccess(ip,cname){
            var source= ''
            if(!this.getSearch().source){
                source=7;
            }else{
                if(this.getSearch().source.indexOf('redirect')!=-1){
                    source=7;
                }else{
                    if(this.getSearch().source.indexOf('-')!=-1){
                        source=this.getSearch().source.split('-')[0];
                    }else{
                        if(this.getSearch().source.indexOf('#')!=-1){
                            source=this.getSearch().source.split('#')[0];
                        }else{
                            source=this.getSearch().source;
                        }
                    }
                }
            }
            if(source==''){
                source=7
            }
            var form={
                accessIp:ip,
                accessSource:source,
                accessAddress:cname
            }
            axios({
                method: 'post',
                url: '/plat/access/source',
                data: form,
                headers: {
                'Content-Type': 'application/json'
                }
            }).then(res => {
                if(res.data.code==200){
                    this.loginId= res.data.data.id;
                }
            })
            // this.$post('/plat/access/source',form,function(res){
            //      if(res.code==200){
            //         this.loginId= res.data.id;
            //     }
            // },true)
        },

        sourceEdit(loginName){
            var form ={
                accessLoginName:loginName,
                accessOperation:1,
                id:this.loginId
            }
            axios({
                method: 'put',
                url: '/plat/access/source',
                data: form,
                headers: {
                'Content-Type': 'application/json'
                }
            }).then(res => {
                if(res.data.code==200){
                    // this.loginId= res.data.id;
                }
            })
            // this.$put('/plat/access/source',form,function(res){
            //      if(res.code==200){
            //        // this.loginId= res.data.id;
            //     }
            // },true)
        },


        //密码的隐藏和显示
        showPass() {
            //点击图标是密码隐藏或显示
            if (this.passw == "text") {
                this.passw = "password";
                //更换图标
                this.icon =1;
            } else {
                this.passw = "text";
                this.icon = 2;
            }
        },
        //密码失焦事件
        onBlur(){
            this.passw = "password";
            this.icon = 1;
        },

        getInfo(){
            //获取微信回调参数
            var code = getSearch('code')?getSearch('code'):this.$route.query.code;
            if(code&&!getSession('open_id')){
                var form = JSON.parse(JSON.stringify(this.form));
                form.auth_type = 'wechat';
                form.code = code;
                form.password = code;
                form.state = this.getSearch().state
                this.logins(form);
            }
        },
         // 获取地址栏参数
        getSearch() {
             // 获取参数
            var url = decodeURI(location.href);
            var theRequest = new Object();
            if (url.indexOf("?") != -1) { 
                var str = url.substr(1); 
                var strs=''
                if(str.indexOf("&") != -1){
                    strs= str.split("&");
                }else{
                    strs= str.split("?")
                }
                for(var i = 0; i < strs.length; i ++) { 
                    theRequest[strs[i].split("=")[0]] = unescape(strs[i].split("=")[1]); 
                }
            }
            return theRequest;
        }

    },
    mounted() {
        this.getInfo();
        this.getIPCity()
    }
}
